define(["require", "exports", "jquery", "./debounce", "./analytics"], function (require, exports, $, debounce_1, analytics_1) {
    "use strict";
    exports.__esModule = true;
    var loadAheadHeight = 200;
    var scrollTrigger = 'scrollTrigger';
    function existsInDom($el) {
        return $el.parent().length > 0;
    }
    function topPath() {
        return window.location.pathname.split('/').slice(0, 3).join('/');
    }
    function hookScroll($mark, handler) {
        var $win = $(window);
        var result = debounce_1["default"](function () {
            if (!existsInDom($mark)) {
                return;
            }
            var pos = $mark[0].getBoundingClientRect();
            var winBottom = $win.scrollTop() + $win.height();
            var screenIndex = Math.round(winBottom / $win.height());
            analytics_1["default"]('scroll', topPath(), null, 0, true);
            if (screenIndex >= 2) {
                $('.back-to-top').show();
            }
            else {
                $('.back-to-top').hide();
            }
            if (pos.top - loadAheadHeight < winBottom && !$mark.data(scrollTrigger)) {
                $mark.data(scrollTrigger, new Date());
                handler();
            }
        }, 200, false);
        $win.on({ 'scroll': result });
        return result;
    }
    exports.hookScroll = hookScroll;
    function unhookScroll(handler) {
        $(window).off('scroll', handler);
    }
    exports.unhookScroll = unhookScroll;
    function resetTrigger($mark) {
        $mark.removeData(scrollTrigger);
    }
    exports.resetTrigger = resetTrigger;
    function limitScroll($sheet, max) {
        var top = $(window).scrollTop();
        if (top < 0) {
            top = 0;
        }
        if (top >= max) {
            top = max;
        }
        var text = $sheet.text();
        $sheet.text(text.replace(/translateY\([^\)]+\)/, "translateY(" + -top + "px)"));
    }
    function startLimitScroll(sel, max) {
        var $win = $(window);
        var $sheet = $(sel);
        var handler = debounce_1["default"](function () { return limitScroll($sheet, max); }, 200, false);
        $win.on({ 'scroll': handler });
        return handler;
    }
    exports.startLimitScroll = startLimitScroll;
    function stopLimitScroll(handler) {
        unhookScroll(handler);
    }
    exports.stopLimitScroll = stopLimitScroll;
    $(function () {
        $('.back-to-top').click(function (e) {
            e.preventDefault();
            e.stopPropagation();
            $(window).scrollTop(0);
            $(e.currentTarget).hide();
        });
    });
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/scrollWatcher.js
// module id = 70
// module chunks = 0